import type { Member } from "@/types/Member";
import z from "zod";

export const PracticeManagerSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string().email(),
  introduction: z.string().optional(),
});

export type PracticeManager = z.infer<typeof PracticeManagerSchema>;

// export type PracticeManager = {
//   id: string;
//   name: string;
//   email: string;
//   introduction?: string;
// };

export type PracticeManagerWithMember = Omit<PracticeManager, keyof Member> & Member;
